import e from"../../internal/SocialSecurityNumberBrazil/validate.js";const r={socialSecurityNumber:{validate:e,errorMessage:"",modes:["blur"]},default:{validate:e=>!!e&&e.length>0,errorMessage:"",modes:["blur"]}};export{r as pixValidationRules};
//# sourceMappingURL=validate.js.map
